const NAME = 'wc_variation';
AC_SERVICES.addListener('Editing.Editables.Ready', (Editables) => {
    const Abstract = Editables.get('_abstract');
    class Variation extends Abstract {
        getEditableType() {
            return NAME;
        }
        focus() {
            let select = this.getElement().querySelector(`select`);
            if (select) {
                select.focus();
            }
        }
        valueToInput(cellvalue) {
            let value = cellvalue.value;
            let attributes = cellvalue.options;
            if (attributes) {
                this.setAttributes(attributes);
            }
            Object.keys(value).forEach((v) => {
                this.getElement().querySelectorAll(`select[name=${v}]`).forEach(s => s.value = value[v]);
            });
        }
        getValue() {
            let result = {};
            this.getElement().querySelectorAll('select').forEach((select) => {
                result[select.dataset.attribute] = select.value;
            });
            return result;
        }
        setAttributes(attributes) {
            let element = this.getElement().querySelector('.attributes');
            Object.keys(attributes).forEach((key) => {
                let attribute = attributes[key];
                element.insertAdjacentHTML('beforeend', this.getAttributeSelect(key, attribute.label, attribute.options));
            });
        }
        getAttributeSelect(key, label, options) {
            let select = document.createElement('select');
            select.setAttribute('name', key);
            select.dataset.attribute = key;
            select.innerHTML = `<option value="">Any ${label}</option>`;
            Object.keys(options).forEach((key) => {
                select.insertAdjacentHTML('beforeend', `<option value="${key}" >${options[key]}</option>`);
            });
            return this.getEditableTemplate().getFormHelper().inputGroup(label, select.outerHTML);
        }
        getTemplate() {
            return `<div class="attributes"></div>`;
        }
    }
    Editables.registerEditable(NAME, Variation);
});
// Register MiddleWare
AC_SERVICES.addListener('Editing.Middleware.Ready', (Middleware) => {
    const Abstract = Middleware.getClass('_abstract');
    class Variation extends Abstract {
        getEditable() {
            return this.Editables.get(NAME);
        }
    }
    Middleware.register(NAME, Variation);
});
export {};
